import { createFileRoute } from '@tanstack/react-router'
import { Farewell } from '@/features/farewell'

export const Route = createFileRoute('/farewell')({
  component: Farewell,
})

